<template>
    <nav>
        <ol>
            <li>
                <router-link to="/home">{{ $t("nav.mainPageTitle") }}</router-link>
                <div>[{{ $t("nav.mainPageTitle") }}]</div>
            </li>
            <li>
                <router-link to="/docs">{{ $t("nav.docPageTitle") }}</router-link>
                <div>[{{ $t("nav.docPageTitle") }}]</div>
            </li>
            <li>
                <router-link to="/credits">{{ $t("nav.creditsPageTitle") }}</router-link>
                <div>[{{ $t("nav.creditsPageTitle") }}]</div>
            </li>
        </ol>
    </nav>
</template>

<script setup lang="ts">
</script>

<style scoped>
nav {
    border-top: 1px var(--outline-colour) solid;
    min-width: 100%;
}

ol {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    gap: 1em;
    justify-content: center;
    font-size: medium;
}

li {
    display: flex;
    flex-direction: column;
    align-items: center;
}

li > div {
    cursor: unset;
    opacity: 0;
}

li:hover > div {
    opacity: 1;
}

li:hover > a.router-link-active + div {
    opacity: 0;
}

li > a {
    text-decoration: none;
    cursor: pointer;
    font-weight: normal;
    color: var(--ink-colour);
    position: absolute;
    opacity: 1;
    z-index: 1;
}

li:hover > a {
    opacity: 0;
}

li > a.router-link-active {
    font-weight: bold;
    cursor: default;
}

li:hover > a.router-link-active {
    opacity: 1;
}

</style>
